<template>
  <div class="hearing-aid">
    <HeroBanner
        :background-image="bannerImage"
        title="보청기 가격"
        sub-title="검증된 글로벌 보청기 브랜드 제조사와 협력하여 중간 유통단계를 줄였습니다. <br> 다비치 히어링 보청기 전국 어느 지점에서나 정액 정찰제로 구매하실 수 있습니다."
    />

    <div class="hearing-aid-content">
      <!-- 제목 섹션 -->
      <div class="heading-section">
        <h2 class="main-title">보청기 가격</h2>
      </div>

      <!-- 가격표 포스터 이미지 -->
      <div class="price-poster">
        <img
          :src="posterImage"
          :srcset="`${posterImage} 1x, ${posterImageRetina} 2x`"
          alt="다비치 히어링 보청기 가격 정찰제 가격표"
          class="poster-image"
        />
      </div>

      <!-- 노블레스 -->
      <div class="grade-table">
        <h3 class="grade-title">노블레스</h3>
        <div class="table-container">
          <div class="table-row">
            <div class="table-label">생활 환경</div>
            <div class="table-value">매일 야외(모임) 활동 생활</div>
          </div>
          <div class="table-row">
            <div class="table-label">대화 상황</div>
            <div class="table-value">큰 소음 상황 속 대규모 그룹 대화</div>
          </div>
          <div class="table-row">
            <div class="table-label">주요 기능</div>
            <div class="table-value">AI 환경 최적화, 헬스케어 기능 등</div>
          </div>
          <div class="table-row price-row">
            <div class="table-label">가격</div>
            <div class="table-value price-value">
              <div class="price-item">
                <span class="price-type one-side">편측</span>
                <span class="price-amount">230만원</span>
              </div>
              <div class="price-item">
                <span class="price-type both-side">양측</span>
                <span class="price-amount">420만원</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 프리미엄 -->
      <div class="grade-table">
        <h3 class="grade-title">프리미엄</h3>
        <div class="table-container">
          <div class="table-row">
            <div class="table-label">생활 환경</div>
            <div class="table-value">자주 야외(모임) 활동</div>
          </div>
          <div class="table-row">
            <div class="table-label">대화 상황</div>
            <div class="table-value">소음 상황 속 대그룹 그룹 대화</div>
          </div>
          <div class="table-row">
            <div class="table-label">주요 기능</div>
            <div class="table-value">충전형 배터리, 맞춤 방향성 조정 등</div>
          </div>
          <div class="table-row price-row">
            <div class="table-label">가격</div>
            <div class="table-value price-value">
              <div class="price-item">
                <span class="price-type one-side">편측</span>
                <span class="price-amount">200만원</span>
              </div>
              <div class="price-item">
                <span class="price-type both-side">양측</span>
                <span class="price-amount">360만원</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 클래식 -->
      <div class="grade-table">
        <h3 class="grade-title">클래식</h3>
        <div class="table-container">
          <div class="table-row">
            <div class="table-label">생활 환경</div>
            <div class="table-value">종종 야외(모임) 활동</div>
          </div>
          <div class="table-row">
            <div class="table-label">대화 상황</div>
            <div class="table-value">소음 상황 속 소규모 대화</div>
          </div>
          <div class="table-row">
            <div class="table-label">주요 기능</div>
            <div class="table-value">블루투스 지원, 자동 환경 인식 등</div>
          </div>
          <div class="table-row price-row">
            <div class="table-label">가격</div>
            <div class="table-value price-value">
              <div class="price-item">
                <span class="price-type one-side">편측</span>
                <span class="price-amount">160만원</span>
              </div>
              <div class="price-item">
                <span class="price-type both-side">양측</span>
                <span class="price-amount">280만원</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 스탠다드 -->
      <div class="grade-table">
        <h3 class="grade-title">스탠다드</h3>
        <div class="table-container">
          <div class="table-row">
            <div class="table-label">생활 환경</div>
            <div class="table-value">거의 실내(집) 위주</div>
          </div>
          <div class="table-row">
            <div class="table-label">대화 상황</div>
            <div class="table-value">조용한 실내에서 2~3명 대화</div>
          </div>
          <div class="table-row">
            <div class="table-label">주요 기능</div>
            <div class="table-value">소음 억제 강화, 피드백 억제 등</div>
          </div>
          <div class="table-row price-row">
            <div class="table-label">가격</div>
            <div class="table-value price-value">
              <div class="price-item">
                <span class="price-type one-side">편측</span>
                <span class="price-amount">120만원</span>
              </div>
              <div class="price-item">
                <span class="price-type both-side">양측</span>
                <span class="price-amount">220만원</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 베이직 -->
      <div class="grade-table">
        <h3 class="grade-title">베이직</h3>
        <div class="table-container">
          <div class="table-row">
            <div class="table-label">생활 환경</div>
            <div class="table-value">항상 실내(집) 위주</div>
          </div>
          <div class="table-row">
            <div class="table-label">대화 상황</div>
            <div class="table-value">조용한 실내에서 1:1 대화 위주</div>
          </div>
          <div class="table-row">
            <div class="table-label">주요 기능</div>
            <div class="table-value">소리 증폭, 잡음 억제 등</div>
          </div>
          <div class="table-row price-row">
            <div class="table-label">가격</div>
            <div class="table-value price-value">
              <div class="price-item">
                <span class="price-type one-side">편측</span>
                <span class="price-amount">80만원</span>
              </div>
              <div class="price-item">
                <span class="price-type both-side">양측</span>
                <span class="price-amount">150만원</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import bannerBg from '@/assets/images/heros/03-top-img.png';
import posterImage from '@/assets/images/banners/03-01-img-01.png';
import posterImageRetina from '@/assets/images/banners/03-01-img-01@2x.png';

export default {
  name: 'PriceHearingAid',
  components: {HeroBanner},
  data() {
    return {
      bannerImage: [bannerBg],
      posterImage: posterImage,
      posterImageRetina: posterImageRetina,
    };
  }
};
</script>

<style scoped lang="scss">
.hearing-aid {
  .hearing-aid-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    padding: 56px 20px 80px;
    background: #FFFFFF;
    gap: 30px;

    .heading-section {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 18px;

      .main-title {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 700;
        font-size: 33px;
        line-height: 45px;
        letter-spacing: -1px;
        color: #222222;
        margin-bottom: 30px;

      }
    }

    .price-poster {
      width: 100%;
      max-width: 500px;

      .poster-image {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    .grade-table {
      width: 100%;
      max-width: 425px;
      display: flex;
      flex-direction: column;
      gap: 24px;
      padding-top: 24px;

      .grade-title {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        letter-spacing: -0.74px;
        color: #222222;
        margin: 0;
      }

      .table-container {
        display: flex;
        flex-direction: column;
        border-top: 1px solid #222222;
        border-bottom: 1px solid #222222;

        .table-row {
          display: flex;
          border-bottom: 1px solid #DDDDDD;

          &:last-child {
            border-bottom: none;
          }

          &.price-row {
            background: #FFFCD5;
            height: 110px;
          }

          .table-label {
            width: 111px;
            min-width: 111px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 22px 0;
            background: #F9F9F9;
            font-family: 'Noto Sans KR', sans-serif;
            font-weight: 700;
            font-size: 18px;
            line-height: 32px;
            letter-spacing: -0.54px;
            color: #222222;
            text-align: center;
            border-right: 1px solid #DDDDDD;
          }

          .table-value {
            flex: 1;
            display: flex;
            align-items: center;
            padding: 22px;
            font-family: 'Noto Sans KR', sans-serif;
            font-weight: 350;
            font-size: 18px;
            line-height: 33px;
            letter-spacing: -0.54px;
            color: #222222;

            &.price-value {
              padding: 0;
              background: #FFFCD5;
              flex-direction: column;

              .price-item {
                flex: 1;
                width: 100%;
                height: 55px;
                display: flex;
                flex-direction: row;
                align-items: center;

                &:last-child {
                  border-top: 1px solid #DEDEDE;
                }

                .price-type {
                  width: 90px;
                  min-width: 90px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  height: 100%;
                  font-family: 'Noto Sans KR', sans-serif;
                  font-weight: 700;
                  font-size: 18px;
                  line-height: 32px;
                  letter-spacing: -0.54px;
                  color: #222222;
                  text-align: center;
                  border-right: 0.93px solid #DEDEDE;
                }

                .price-amount {
                  flex: 1;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  height: 100%;
                  font-family: 'Noto Sans KR', sans-serif;
                  font-weight: 350;
                  font-size: 18px;
                  line-height: 33px;
                  letter-spacing: -0.54px;
                  color: #222222;
                  text-align: center;
                }
              }
            }
          }

          &.price-row .table-label {
            background: #FFFCD5;
            height: 110px;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .hearing-aid-content {
      padding: 40px 20px 60px;
      gap: 24px;

      .heading-section {
        gap: 16px;

        .main-title {
          font-size: 28px;
          line-height: 38px;
        }
      }

      .grade-table {
        max-width: 100%;
        gap: 20px;
        padding-top: 20px;

        .grade-title {
          font-size: 22px;
          line-height: 30px;
        }

        .table-container {
          .table-row {
            &.price-row {
              height: 90px;
            }

            .table-label {
              width: 90px;
              min-width: 90px;
              padding: 18px 0;
              font-size: 16px;
              line-height: 28px;
            }

            .table-value {
              padding: 18px;
              font-size: 16px;
              line-height: 28px;

              &.price-value {
                .price-item {
                  height: 45px;

                  .price-type {
                    width: 75px;
                    min-width: 75px;
                    font-size: 16px;
                    line-height: 28px;
                  }

                  .price-amount {
                    font-size: 16px;
                    line-height: 28px;
                  }
                }
              }
            }

            &.price-row .table-label {
              height: 90px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 450px) {
    .hearing-aid-content {
      padding: 30px 20px 50px;
      gap: 20px;

      .heading-section {
        gap: 14px;

        .main-title {
          font-size: 24px;
          line-height: 34px;
        }
      }

      .grade-table {
        gap: 18px;
        padding-top: 18px;

        .grade-title {
          font-size: 20px;
          line-height: 28px;
        }

        .table-container {
          .table-row {
            &.price-row {
              height: 80px;
            }

            .table-label {
              width: 80px;
              min-width: 80px;
              padding: 16px 0;
              font-size: 15px;
              line-height: 26px;
            }

            .table-value {
              padding: 16px;
              font-size: 15px;
              line-height: 26px;

              &.price-value {
                .price-item {
                  height: 40px;

                  .price-type {
                    width: 65px;
                    min-width: 65px;
                    font-size: 15px;
                    line-height: 26px;
                  }

                  .price-amount {
                    font-size: 15px;
                    line-height: 26px;
                  }
                }
              }
            }

            &.price-row .table-label {
              height: 80px;
            }
          }
        }
      }
    }
  }
}
</style>
